import { inject} from '@angular/core';
import { AdminService } from '../_services/admin.service';
import { CanActivateFn } from '@angular/router';

export const adminGuard: CanActivateFn = () => inject(AdminService).isAdmin();
